import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const ModalBlock = styled.form`
  display: flex;
  flex-direction: column;
`;

const Formation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 20px 24px;
  ${mobile_xl(css`
    margin: 16px 16px 0 16px;
    gap: 16px;
  `)}
`;

const Input = styled.input`
  width: -webkit-fill-available;
  padding: 7px 12px;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  ${Typography.body_lg}
  color: var(--text-primary);
  ::placeholder {
    color: var(--text-placeholder);
  }
  :focus {
    border: 0.5px solid var(--brand-primary);
  }
  :focus-visible {
    outline: none;
  }
`;

const FormBlock = styled.div`
  display: flex;
  gap: 16px;
  ${mobile_xl(css`
    flex-direction: column;
    gap: 20px;
  `)}
`;

const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  .fillColor {
    stroke: var(--text-primary);
  }
  .select {
    .angleDown-icon {
      path {
        stroke: var(--text-primary);
      }
    }
  }
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  span {
    color: var(--accent-error);
  }
`;

const FormButton = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 0 16px 16px 0;
  ${mobile_xl(css`
    padding-top: 24px;
    justify-content: end;
    gap: 12px;
  `)}
`;

const FormView = styled.div`
  position: relative;
  z-index: 1;
`;

const SelectInput = styled.input`
  min-width: 566px;
  padding: 7px 12px;
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  background-color: var(--background-primary);
  ${Typography.body_lg}
  ::placeholder {
    color: var(--text-placeholder);
  }
  :focus-visible {
    border-color: var(--brand-primary);
    outline: unset;
  }
  ${mobile_xl(css`
    min-width: calc(100vw - 90px);
  `)}
`;

const ItemDiv = styled.div`
  margin-right: 4px;
  ::-webkit-scrollbar-thumb {
    background: var(--text-placeholder);
    border-radius: 12px;
    min-height: 28px;
  }
`;

const InputDiv = styled.div`
  position: relative;
`;

const IconDiv = styled.div`
  position: absolute;
  top: 8px;
  right: 10px;
  svg {
    stroke: var(--text-primary);
  }
  .angleDown-icon {
    transition: transform 0.3s ease;
  }
  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;

const SelectedText = styled.div`
  position: absolute;
  top: 8px;
  left: 12px;
  pointer-events: none;
  color: var(--text-primary);
  ${Typography.body_lg}
`;
export {
  ModalBlock,
  FormBlock,
  Form,
  Label,
  FormButton,
  Input,
  Formation,
  FormView,
  ItemDiv,
  IconDiv,
  InputDiv,
  SelectInput,
  SelectedText
};
